import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BankAccountSelectComponent } from './bank-account-select.component';
import { PreloaderModule, ValidationErrorModule } from '@shared/component';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';
import { RouterLink } from '@angular/router';


@NgModule({
  declarations: [BankAccountSelectComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    DirectivesModule,
    ValidationErrorModule,
    PreloaderModule,
    RouterLink
  ],
  exports: [BankAccountSelectComponent]
})
export class BankAccountSelectModule {
}
